import { http } from 'services/http';
import { endpoint } from 'services/endpoint';
import { TJotformApi } from './types';

const getJotforms: TJotformApi['getJotforms'] = data =>
	http.post(endpoint.jotform.SEARCH, data).then(response => response.data);

const getJotform: TJotformApi['getJotform'] = id =>
	http.get(endpoint.jotform.GET_BY_ID(id)).then(response => response.data);

const createEmerchant: TJotformApi['createEmerchant'] = data =>
	http.post(endpoint.jotform.CREATE_EMERCHANT(data.jotformId), data.data);

export const jotform: TJotformApi = {
	getJotforms,
	getJotform,
	createEmerchant,
};
